"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconLock = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z M9.1875,8.09654164 L9.1875,9.33447394 L7.5,9.33447394 L7.5,18 L16.5,18 L16.5,9.33447394 L14.8125,9.33447394 L14.8125,8.22652453 C14.8125,6.61102289 13.738125,5.16883177 12.275625,5.01409023 C10.599375,4.84077971 9.1875,6.28916049 9.1875,8.09654164 Z M15.375,10.5724062 L15.375,16.7620677 L8.625,16.7620677 L8.625,10.5724062 L15.375,10.5724062 Z M12,12.4293047 C11.38125,12.4293047 10.875,12.9863742 10.875,13.667237 C10.875,14.3480997 11.38125,14.9051693 12,14.9051693 C12.61875,14.9051693 13.125,14.3480997 13.125,13.667237 C13.125,12.9863742 12.61875,12.4293047 12,12.4293047 Z M13.6875,8.09654164 L13.6875,9.33447394 L10.3125,9.33447394 L10.3125,8.09654164 C10.3125,7.3971099 10.65,6.71005747 11.235,6.42533305 C12.478125,5.81255656 13.6875,6.79671273 13.6875,8.09654164 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconLock')(IconLock);